import Panel from 'components/Panel';
import {useTranslation} from 'react-i18next';
import React from 'react';
import Button from 'components/Button';
import Typography from '@mui/material/Typography';
import {IDiplomatObject} from 'types/DiplomatObject';
import Grid from '@mui/material/Grid';
import FileManagerDialog from 'features/layout/DialogRoutes/dialogs/FileManagerDialog/FileManagerCreateDialog';
import {useModal} from 'common/hooks/useModal';
import SearchResultsList from 'components/SearchResultsList';

type SearchResultsProps = {
   label: string;
   data?: IDiplomatObject[];
   resultListComponent?: React.ReactNode;
   onExport: (data: string) => void; //{csvFile: string; transactions: IDiplomatObject[]}
};

const SearchResults = ({label, data = [], resultListComponent, onExport}: SearchResultsProps) => {
   const {t} = useTranslation();
   const {open, handleOpen, handleClose} = useModal();

   return (
      <Panel name={t('Search Results')}>
         <Typography variant={'body2'} gutterBottom>
            {label}
         </Typography>
         <Typography variant={'body2'} gutterBottom>
            {t('Drag and drop in navigation tree to move between folders.')}
         </Typography>
         <Grid container spacing={2}>
            {resultListComponent ? (
               resultListComponent
            ) : (
               <Grid item xs={12}>
                  <SearchResultsList data={data} />
               </Grid>
            )}
            <Grid item xs={12}>
               <FileManagerDialog
                  // filesOfType={['*.csv']}
                  open={open}
                  onConfirm={onExport}
                  onClose={handleClose}
               />
               <Button disabled={data?.length === 0} onClick={handleOpen}>
                  {t('Export')}
               </Button>
            </Grid>
         </Grid>
      </Panel>
   );
};

export default SearchResults;
